import { ConnectionTypeDocumentModel } from "./ConnectionTypeDocument.model";
import { LanguageModel } from "./Language.model";

export class ConnectionTypeDocumentFormatModel {
    
    Id : number;
    Name: string;
    IdConnectionTypeDocument : number;
    Terms : string;
    Format : string;
    IsActive : boolean;
    CreatedBy : string;
    CreatedDate : Date;
    ModifiedBy : string;
    ModifiedDate : Date;
    FormatPath : string;
    Extension : string;
    IdLanguage: number;
    
    IdLanguageNavigation : LanguageModel;
    IdConnectionTypeDocumentNavigation: ConnectionTypeDocumentModel; 
   
}